import { render, staticRenderFns } from "./Bannermanage.vue?vue&type=template&id=01cd3f09&scoped=true&"
import script from "./Bannermanage.vue?vue&type=script&lang=js&"
export * from "./Bannermanage.vue?vue&type=script&lang=js&"
import style0 from "./Bannermanage.vue?vue&type=style&index=0&id=01cd3f09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd3f09",
  null
  
)

export default component.exports